import { useEffect, useState } from "react";
import Accordion from "../Accordion";
import styles from "./style.module.css";
import propTypes from "prop-types";

const LearnMore = ({ controller_code, customer_scope, language }) => {
  const [learMore, setLearMore] = useState(null);
  useEffect(() => {
    const fetchLearnMoreContent = async () => {
      const domain = import.meta.env.VITE_DOMAIN;
      try {
        const response = await fetch(
          `${domain}/${controller_code}/${customer_scope}/${language}/cs/consent_side_navigation.json`,
        );
        const data = await response.json();
        setLearMore(data);
      } catch (error) {
        setLearMore(null);
        console.error("Error fetching Learn More content", error);
      }
    };
    fetchLearnMoreContent();
  }, []);
  if (learMore)
    return (
      <section>
        <h2 className={styles["learn-more__title"]}>{learMore?.heading}</h2>
        <Accordion accordionItems={learMore?.body} />
      </section>
    );
};

export default LearnMore;

LearnMore.propTypes = {
  controller_code: propTypes.string,
  customer_scope: propTypes.string,
  language: propTypes.string,
};
